import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { UsersStore } from '@data-access/user/stores/users.store';
import { ContactUsPayload } from '@shared/interfacres/common';
import { MatOption } from '@angular/material/autocomplete';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-contact-us',
  imports: [
    MatButton,
    ReactiveFormsModule,
    MatOption,
    MatSelect
  ],
  templateUrl: './contact-us.html',
  styleUrl: './contact-us.scss'
})
export class ContactUs {
  maxMessageLength = 2000;
  private store = inject(UsersStore);

  reasons = [
    'Billing Department',
    'Tech Support',
    'Music Submissions',
    'Other Request'
  ];

  form = new FormGroup({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    subject: new FormControl('', [Validators.required]),
    reason: new FormControl('', [Validators.required]),
    message: new FormControl('', [Validators.required, Validators.maxLength(this.maxMessageLength)]),
  });

  async send() {
    const res = await this.store.contactUs(this.form.value as ContactUsPayload);
    if (res) {
      this.form.reset();
    }
  }
}
